export const REFER_USER_URL = 'https://w3.portfoplus.com/partner/adviser-exclusive';
export const ADVISER_FAQ_URL = 'https://w3.portfoplus.com/partner/adviser-exclusive-faq/';
